import { FinalSubmittedComponentDetails } from "src/components/feature/AddMonitoringDetails/FinalSubmittedDetails";

export default function MonitoringSubmitted() {
  return <FinalSubmittedComponentDetails />;
}
